import { c as _c } from "react/compiler-runtime";
import { FileSelectorModal, FileSelectorModalProps, FileSourceEnum, FileTypeEnum, FileUploaderDropZone, FileUploaderDropZoneProps } from '@systemeio/file-manager';
import { ComponentProps, PropsWithChildren, useRef, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
interface DropZoneProps extends Pick<FileUploaderDropZoneProps, 'icon' | 'label' | 'variant' | 'error' | 'isPreFetching' | 'disabled' | 'className' | 'dropZoneClassName' | 'labelClassName'> {}
type ImageCropperModalProps = NonNullable<FileSelectorModalProps['fileUploaderModalProps']>['imageCropperModalProps'];
interface Props extends PropsWithChildren, DropZoneProps {
  source: FileSourceEnum;
  imageCropperModalProps?: ImageCropperModalProps;
  showDropZone?: boolean;
  acceptTypes?: FileTypeEnum[];
  statusIcon?: React.ReactNode;
  isSuccess?: boolean;
  disabledFileTypeSelect?: ComponentProps<typeof FileSelectorModal>['disabledFileTypeSelect'];
  onSelect: ComponentProps<typeof FileSelectorModal>['onSelect'];
}
export const FileUploader = t0 => {
  const $ = _c(40);
  const {
    icon,
    label,
    acceptTypes,
    variant,
    error,
    isPreFetching,
    disabled,
    children,
    showDropZone: t1,
    className,
    dropZoneClassName,
    labelClassName,
    source,
    imageCropperModalProps,
    statusIcon,
    isSuccess,
    disabledFileTypeSelect: t2,
    onSelect
  } = t0;
  const showDropZone = t1 === undefined ? true : t1;
  const disabledFileTypeSelect = t2 === undefined ? true : t2;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const uploaderRef = useRef(undefined) as NonNullable<FileSelectorModalProps['fileUploaderModalProps']>['uploaderRef'];
  const fileSelectorRef = useRef(undefined);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== acceptTypes) {
    t4 = acceptTypes ?? [];
    $[1] = acceptTypes;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = {
      name: "",
      source: t3,
      type: t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const initialSearchFilters = t5;
  let t6;
  if ($[5] !== acceptTypes || $[6] !== children || $[7] !== className || $[8] !== disabled || $[9] !== dropZoneClassName || $[10] !== error || $[11] !== icon || $[12] !== isPreFetching || $[13] !== isSuccess || $[14] !== label || $[15] !== labelClassName || $[16] !== showDropZone || $[17] !== statusIcon || $[18] !== t || $[19] !== variant) {
    t6 = showDropZone && <FileUploaderDropZone icon={icon} label={label ?? t("global.select_image")} acceptTypes={acceptTypes} variant={variant} error={error} isPreFetching={isPreFetching} disabled={disabled} className={className} dropZoneClassName={twMerge(dropZoneClassName, statusIcon && "relative", isSuccess && "border-green border-solid hover:border-green")} labelClassName={labelClassName} openNativeWindow={false} onClick={() => {
      setOpened(true);
    }} onSelectFile={file => {
      setOpened(true);
      setTimeout(() => {
        fileSelectorRef?.current?.setFileUploadModalOpen(true);
        uploaderRef?.current?.setWaitingUploadFiles(prev => [...prev, {
          file
        }]);
      });
    }}>{statusIcon && <div className="absolute right-2 top-2">{statusIcon}</div>}{children}</FileUploaderDropZone>;
    $[5] = acceptTypes;
    $[6] = children;
    $[7] = className;
    $[8] = disabled;
    $[9] = dropZoneClassName;
    $[10] = error;
    $[11] = icon;
    $[12] = isPreFetching;
    $[13] = isSuccess;
    $[14] = label;
    $[15] = labelClassName;
    $[16] = showDropZone;
    $[17] = statusIcon;
    $[18] = t;
    $[19] = variant;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = imageCropperModalProps?.allowSwitchingCroppingShape;
  const t8 = imageCropperModalProps?.isRounded;
  const t9 = imageCropperModalProps?.imageCropperProps?.aspectRatio ?? NaN;
  let t10;
  if ($[21] !== t9) {
    t10 = {
      aspectRatio: t9
    };
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t7 || $[25] !== t8) {
    t11 = {
      uploaderRef,
      imageCropperModalProps: {
        allowSwitchingCroppingShape: t7,
        isRounded: t8,
        imageCropperProps: t10
      }
    };
    $[23] = t10;
    $[24] = t7;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== onSelect) {
    t12 = file_0 => {
      setOpened(false);
      onSelect(file_0);
    };
    $[27] = onSelect;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setOpened(false);
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== disabledFileTypeSelect || $[31] !== initialSearchFilters || $[32] !== opened || $[33] !== source || $[34] !== t11 || $[35] !== t12) {
    t14 = <FileSelectorModal opened={opened} uploadingFromSource={source} fileSelectorRef={fileSelectorRef} disabledFileTypeSelect={disabledFileTypeSelect} initialSearchFilters={initialSearchFilters} fileUploaderModalProps={t11} onSelect={t12} onClose={t13} />;
    $[30] = disabledFileTypeSelect;
    $[31] = initialSearchFilters;
    $[32] = opened;
    $[33] = source;
    $[34] = t11;
    $[35] = t12;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14 || $[38] !== t6) {
    t15 = <>{t6}{t14}</>;
    $[37] = t14;
    $[38] = t6;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
};